export default "__VITE_ASSET__C1N7t76y__"